module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chap-title1",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("Understanding Macraweave")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("A macraweave is a fusion of the textile-making arts of macramé and weaving, but to understand the macraweave, we must first take a look at macramé and its negative spaces.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_vm._v("The negative spaces in a macramé piece are the areas where there are no knots tied. The vertical cords of these negative spaces resemble that of the warp threads in weaving and can therefore be used in the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A macraweave is made by first making a macramé structure with a negative space or spaces, then applying weaving techniques through the negative space of the macramé. The tension of the negative space is very important as there is no device (such as a loom) to facilitate the weave, so you must make sure that all the vertical cords in the negative space are uniformly taut before attempting to weave through them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Once you have created a negative space (the warp) you will begin to weave in new threads horizontally using weaving techniques. These cords can be referred to as the weft and it is also important to keep a uniform tension with these cords.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P8-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The macramé structure is the first stage of creating a macraweave piece. The vertical cords where no macramé knots are tied, that is the negative space, act as the warp. It is important to keep these cords uniformly taut so your weaving is neat.")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once the macramé element is complete, the weaving element can begin. Here the peach rope is the weft and it has been woven through the negative space using a simple tabby weave in a two over two under pattern.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Note:")]), _vm._v(" Each project features a photo or photos annotated with circled numbers that cross reference to the step-by-step instructions. However, due to the nature of creating the piece, some steps can’t be shown, e.g., mounting techniques, or where macramé cords have been woven over, or where rya knot fringing (Pride and Joy Wall Hanging) or project construction (shoulder bag and clutch purse) obscures steps. Take the time to read the pattern instructions carefully before you begin.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "box-head1",
    attrs: {
      "id": "box1"
    }
  }, [_vm._v("Essential Terminology")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Before you start on your macraweave journey, there is some essential terminology that you need to familiarise yourself with. This list covers all of the terms used for the macramé knotting and weaving techniques:")])]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Negative space:")]), _vm._v(" The area where there are no knots tied in a macramé piece. The negative space is used as the warp threads in a macraweave.")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Warp:")]), _vm._v(" The vertical yarns that are held stationary and through which the weft threads are woven. In a macraweave, the warp will be comprised of pre-existing macramé threads rather than the cords that are attached to the loom in traditional weaving.")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Weft:")]), _vm._v(" The yarn or set of yarns that are worked through the weft threads in a horizontal manner.")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Sinnet:")]), _vm._v(" A vertical column of tied knots.")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Row:")]), _vm._v(" A series of knots tied side by side.")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Working cords:")]), _vm._v(" The cords that are used to create the knot.")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Filler cords:")]), _vm._v(" The non–working cords around which the working cords are tied.")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Holding cord:")]), _vm._v(" The object onto which cords are tied, that is a ring, a dowel or another piece of rope.")]), _vm._v(" "), _c('p', {
    staticClass: "box-text1"
  }, [_c('b', [_vm._v("Alternate cords:")]), _vm._v(" The means by which you create a new knot by taking half of the cords from a previous knot together with half of the cords from its adjacent knot to form a new group.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 72
// module chunks = 0